import { render, staticRenderFns } from "./EnergyFlowView.vue?vue&type=template&id=45ea2bf4&"
import script from "./EnergyFlowView.vue?vue&type=script&lang=ts&"
export * from "./EnergyFlowView.vue?vue&type=script&lang=ts&"
import style0 from "./EnergyFlowView.vue?vue&type=style&index=0&id=45ea2bf4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports